import styled from '@emotion/styled';

import { AppTheme } from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';

export const Label = styled.span`
  text-transform: uppercase;
  font-family: ${({ theme }) => (theme as AppTheme).fonts.fontBold};
  font-size: ${({ theme }) => (theme as AppTheme).fontSizes[3]};
  color: ${({ theme }) => (theme as AppTheme).colors.darkGray};
`;

export const Logo = styled.img`
  display: block;
  height: ${rem(24)};
  width: auto;
`;
